import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<main id=\"main\" name=\"main\">\n  {{yield}}\n</main>\n")